const actions = {
  async errorCancellingPin({dispatch}) {
    dispatch('popups/show/error/custom', 'cancelling your pin', {root: true})
  },
};

export default {
  actions
};
